/**
 * Typography used in theme
 * @param {JsonObject} theme theme customization object
 */

import { TypographyOptions } from "@mui/material/styles/createTypography";

export const themeTypography = (): TypographyOptions => {
	return {
		fontFamily: [
			'Plus Jakarta Sans', 'sans-serif'].join(','),
		h5: {
			fontWeight: 'bold',
			fontSize: 27
		},
		h6: {
			fontWeight: 'bold',
			fontSize: 22
		},
		subtitle2: {
			fontWeight: 'bold',
			fontSize: 15
		},
		
	};
};
